export const DAO_CODE = 'SENIORIty' + '_DAO';
